import React from 'react'

export default function ConversationIcon({ width = 15, height = 15, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 14.5635V1.45635C0 1.05585 0.142601 0.713004 0.427802 0.427802C0.713004 0.142601 1.05585 0 1.45635 0H13.1071C13.5076 0 13.8505 0.142601 14.1357 0.427802C14.4209 0.713004 14.5635 1.05585 14.5635 1.45635V10.1944C14.5635 10.5949 14.4209 10.9378 14.1357 11.223C13.8505 11.5082 13.5076 11.6508 13.1071 11.6508H2.9127L0 14.5635ZM2.9127 8.73809H8.73809V7.28174H2.9127V8.73809ZM2.9127 6.55356H11.6508V5.09722H2.9127V6.55356ZM2.9127 4.36904H11.6508V2.9127H2.9127V4.36904Z" fill="#2E62FF"/>
    </svg>
  )
}
